module.exports = __webpack_public_path__ + "static/media/UniTrack_preview.6c4ccc62.jpg";